// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3kf-m","title":"BackImages_title__3La19","images":"BackImages_images__7ko2c"};